// extracted by mini-css-extract-plugin
export var component = "LeadParagraph-module--component--43212";
export var fadePop = "LeadParagraph-module--fade-pop--863ad";
export var growHeightIn = "LeadParagraph-module--grow-height-in--b8ab7";